import { render, staticRenderFns } from "./CriteriaView.vue?vue&type=template&id=b1c21ca4"
import script from "./CriteriaView.vue?vue&type=script&lang=js"
export * from "./CriteriaView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports